import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoCircleFilled } from '@ant-design/icons';
import { PRICE_WRAPPER_MAX_WIDTH_NARROW } from 'components/ReferencePriceSection/PriceErrorDisplay';
import color from 'styles/color.json';
import { Flex, Text } from 'UI';
import { SAlert } from './ReferencePriceSection.styled';

export const PriceUnavailable = ({ narrow, hasStockAtR1 }: { narrow?: boolean; hasStockAtR1?: boolean }) => {
  const { t } = useTranslation();
  const description = hasStockAtR1
    ? t('common.price.unavailable.stocks_at_r1.description', 'Please contact your distributor.')
    : t('common.price.unavailable.description', 'Please try again later.');
  return (
    <Flex maxWidth={narrow ? PRICE_WRAPPER_MAX_WIDTH_NARROW : 230} data-cy={'price-unavailable-banner'}>
      {narrow ? (
        <>
          <InfoCircleFilled style={{ color: color['warning'], marginRight: '5px' }} />
          <Text type="sm" displayStyle={'warning'} cursor={'pointer'} decoration={'underline'}>
            {t('common.price.unavailable', 'Price currently unavailable')}
          </Text>
          <Text type="base">{description}</Text>
        </>
      ) : (
        <SAlert
          icon={<InfoCircleFilled />}
          message={t('common.price.unavailable', 'Price currently unavailable')}
          description={description}
        />
      )}
    </Flex>
  );
};
